import React from "react";
import { HashRouter as Router, Routes, Route, Link } from "react-router-dom";
import PactesStat from "./PactesStat"; // Le composant de statistiques

// Le composant Home est maintenant une page secondaire (ex: pour des informations supplémentaires)
function Home() {
  return (
    <div style={{ padding: "20px" }}>
      <h1>Page Secondaire (Home)</h1>
      <p>Bienvenue dans cette page secondaire 🚀</p>
      <nav>
        <Link to="/">Voir les Statistiques (Accueil)</Link> | 
        <Link to="/about">Aller à la page About</Link>
      </nav>
    </div>
  );
}

function About() {
  return (
    <div style={{ padding: "20px" }}>
      <h1>À propos</h1>
      <p>Ceci est une page secondaire.</p>
      <nav>
        <Link to="/">Retour à l'Accueil (Statistiques)</Link> | 
        <Link to="/home">Aller à la page Home</Link>
      </nav>
    </div>
  );
}

function App() {
  return (
    <Router>
      {/* Barre de navigation globale (optionnelle) */}
      <nav className="main-nav">
          <Link to="/">Statistiques</Link>
          <Link to="/home">Accueil Secondaire</Link>
          <Link to="/about">À Propos</Link>
      </nav>
      <Routes>
        {/* LA PAGE D'ACCUEIL EST MAINTENANT LE COMPOSANT STATISTIQUES */}
        <Route path="/" element={<PactesStat />} /> 
        
        {/* Les autres routes sont conservées */}
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </Router>
  );
}

export default App;